<ion-header [translucent]="true">
    <ion-toolbar class="ion-padding-end">
        <ion-title slot="start" class="title-truncate">
            {{ Mode === 'crud' ? 'Associar ao Marketplace Mygon' : 'Matches' }}
        </ion-title>
        <ion-buttons slot="end">
            <!-- Marketplace mode — botões de topo -->
            <ng-container *ngIf="Mode === 'marketplace'">
                <ion-button fill="solid" color="primary" (click)="Confirm()"
                    *ngIf="SelectedMatch && IsSynchronized==false">
                    Confirmar Associação
                </ion-button>
                <ion-button fill="outline" color="primary" (click)="ConfirmCreate()"
                    *ngIf="!SelectedMatch && IsSynchronized==false">
                    Criar Estabelecimento
                </ion-button>
                <ion-button fill="outline" color="primary"
                    *ngIf="IsSynchronized && +SelectedMatch?.Status?.Id === EnumMerchantStatus.Accepted"
                    [actionsPermissions]="EnumActionsPermissions.SYNCWALLETCONSUMER"
                    (click)="ForceUpdateMerchantSync()" title="Atualizar a sincronização de dados">
                    Atualizar
                </ion-button>
                <ion-button fill="outline" color="danger" title="Remover Associação" *ngIf="IsSynchronized && SelectedMatch"
                    (click)="OnRemoveMatchAssociation()">
                    Remover
                </ion-button>
            </ng-container>

            <!-- CRUD mode — botões de topo (os que estavam no card de associação atual) -->
            <ng-container *ngIf="Mode === 'crud'">
                <ion-button fill="outline" color="primary"
                    *ngIf="IsAssociated && +MerchantStatusId === EnumMerchantStatus.Accepted"
                    [actionsPermissions]="EnumActionsPermissions.SYNCWALLETCONSUMER"
                    (click)="ForceUpdateMerchantSync()" title="Atualizar a sincronização de dados">
                    Atualizar
                </ion-button>
                <ion-button fill="outline" color="danger" title="Remover Associação" *ngIf="IsAssociated" (click)="OnDisassociate()">
                    Remover
                </ion-button>
            </ng-container>

            <ion-button style="margin-right: -16px;margin-left:8px" fill="clear" color="dark" shape="round" (click)="Close()">
                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" [fullscreen]="true">

    <!-- Card rico "Comerciante Marketplace" — comum aos 2 modos -->
    <div class="source-merchant-card" *ngIf="DisplayMerchant">
        <p class="source-merchant-label">Comerciante Marketplace</p>

        <div class="detail-images" *ngIf="DisplayMerchant?.Images?.length > 0">
            <img *ngFor="let img of DisplayMerchant.Images; let first = first" [src]="img"
                [class.main-image]="first" (click)="OpenPreview(img, $event)" />
        </div>

        <div class="detail-grid">

            <div class="detail-field" *ngIf="DisplayMerchant?.Name">
                <span class="field-label">Nome</span>
                <span class="field-value">{{ DisplayMerchant.Name }}</span>
            </div>

            <div class="detail-field" *ngIf="DisplayMerchant?.VatNumber">
                <span class="field-label">NIPC</span>
                <span class="field-value">{{ DisplayMerchant.VatNumber }}</span>
            </div>

            <div class="detail-field" *ngIf="DisplayMerchant?.Url">
                <span class="field-label">Endereço Marketplace</span>
                <span class="field-value">
                    <a [href]="DisplayMerchant.Url" target="_blank" rel="noopener noreferrer">{{ DisplayMerchant.Url }}</a>
                </span>
            </div>

            <div class="detail-field full-width" *ngIf="DisplayMerchant?.Address">
                <span class="field-label">Morada</span>
                <span class="field-value">
                    {{ DisplayMerchant.Address }}
                    <ng-container *ngIf="DisplayMerchant?.Locality">, {{ DisplayMerchant.Locality }}</ng-container>
                    <ng-container *ngIf="DisplayMerchant?.ZipCode"> {{ DisplayMerchant.ZipCode }}</ng-container>
                    <ng-container *ngIf="DisplayMerchant?.District"> — {{ DisplayMerchant.District }}</ng-container>
                </span>
            </div>

            <div class="detail-field" *ngIf="DisplayMerchant?.Phone">
                <span class="field-label">Telefone</span>
                <span class="field-value">{{ DisplayMerchant.Phone }}</span>
            </div>

            <div class="detail-field" *ngIf="DisplayMerchant?.MobilePhone">
                <span class="field-label">Telemóvel</span>
                <span class="field-value">{{ DisplayMerchant.MobilePhone }}</span>
            </div>

            <div class="detail-field" *ngIf="DisplayMerchant?.Email">
                <span class="field-label">Email</span>
                <span class="field-value">{{ DisplayMerchant.Email }}</span>
            </div>

            <div class="detail-field" *ngIf="DisplayMerchant?.Website">
                <span class="field-label">Website</span>
                <span class="field-value">
                    <a [href]="DisplayMerchant.Website" target="_blank" rel="noopener noreferrer">{{ DisplayMerchant.Website }}</a>
                </span>
            </div>

            <div class="detail-field full-width" *ngIf="DisplayMerchant?.Description">
                <span class="field-label">Descrição</span>
                <span class="field-value description-value" [innerHTML]="DisplayMerchant.Description"></span>
            </div>

        </div>
    </div>

    <!-- ═══ Marketplace mode — lista de matches ═══ -->
    <ng-container *ngIf="Mode === 'marketplace'">

        <p class="section-label" *ngIf="FilteredMatches?.length>0">Estabelecimentos da Plataforma do Cartão</p>

        <ion-grid class="table" *ngIf="FilteredMatches?.length>0">

            <ion-row class="table-header">
                <ion-col size="1" class="flex-align-center flex-justify-center"></ion-col>
                <ion-col class="flex-align-center">Nome</ion-col>
                <ion-col size="2" class="flex-align-center">NIF/NIPC</ion-col>
                <ion-col size="2" class="flex-align-center">Tipo de Match</ion-col>
                <ion-col size="2" class="flex-align-center">Estado</ion-col>
            </ion-row>

            <ng-container *ngFor="let match of FilteredMatches">

                <ion-row class="table-body clickable" [class.row-selected]="SelectedMatch?.Id === match?.Id"
                    (click)="ToggleExpand(match)">
                    <ion-col size="1" class="flex-align-center flex-justify-center" (click)="ToggleSelect(match, $event)">
                        <ion-icon [name]="SelectedMatch?.Id === match?.Id ? 'checkbox' : 'square-outline'"
                            [color]="SelectedMatch?.Id === match?.Id ? 'primary' : 'medium'">
                        </ion-icon>
                    </ion-col>
                    <ion-col class="flex-align-center">{{ match?.Name || '--' }}</ion-col>
                    <ion-col size="2" class="flex-align-center">{{ match?.VatNumber || '--' }}</ion-col>
                    <ion-col size="2" class="flex-align-center">{{ match?.MatchType || '--' }}</ion-col>
                    <ion-col size="2" class="flex-align-center">
                        <icon-status *ngIf="match?.Status?.Name" [icon]="match?.Status?.Icon"
                            [color]="match?.Status?.Color" [title]="match?.Status?.Name"></icon-status>
                    </ion-col>
                </ion-row>

                <!-- Collapse detail row -->
                <ion-row class="match-detail-row" [class.is-expanded]="ExpandedMatchId === match?.Id">
                    <ion-col size="12">
                        <div class="match-detail-inner">
                            <div class="detail-images" *ngIf="match?.Data?.Images?.length > 0">
                                <img *ngFor="let img of match.Data.Images; let first = first" [src]="img"
                                    [class.main-image]="first" (click)="OpenPreview(img, $event)" />
                            </div>
                            <div class="detail-grid">

                                <div class="detail-field full-width" *ngIf="match?.Data?.Description">
                                    <span class="field-label">Descrição</span>
                                    <span class="field-value" [innerHTML]="match.Data.Description"></span>
                                </div>

                                <div class="detail-field full-width" *ngIf="match?.Data?.Address">
                                    <span class="field-label">Morada</span>
                                    <span class="field-value">{{ match.Data.Address }}</span>
                                </div>

                                <div class="detail-field" *ngIf="match?.Data?.Phone">
                                    <span class="field-label">Telefone</span>
                                    <span class="field-value">{{ match.Data.Phone }}</span>
                                </div>

                                <div class="detail-field" *ngIf="match?.Data?.MobilePhone">
                                    <span class="field-label">Telemóvel</span>
                                    <span class="field-value">{{ match.Data.MobilePhone }}</span>
                                </div>

                                <div class="detail-field" *ngIf="match?.Data?.Email">
                                    <span class="field-label">Email</span>
                                    <span class="field-value">{{ match.Data.Email }}</span>
                                </div>

                            </div>
                        </div>
                    </ion-col>
                </ion-row>

            </ng-container>

            <!-- No matches with Id — show item root Data -->
            <ng-container *ngIf="FilteredMatches.length === 0">

                <ion-row *ngIf="ItemData; else noItems">
                    <ion-col size="12">
                        <div class="match-detail-inner is-open">
                            <div class="detail-images" *ngIf="ItemData?.Images?.length > 0">
                                <img *ngFor="let img of ItemData.Images; let first = first" [src]="img"
                                    [class.main-image]="first" (click)="OpenPreview(img, $event)" />
                            </div>
                            <div class="detail-grid">

                                <div class="detail-field full-width" *ngIf="ItemData?.Description">
                                    <span class="field-label">Descrição</span>
                                    <span class="field-value" [innerHTML]="ItemData.Description"></span>
                                </div>

                                <div class="detail-field full-width" *ngIf="ItemData?.Address">
                                    <span class="field-label">Morada</span>
                                    <span class="field-value">{{ ItemData.Address }}</span>
                                </div>

                                <div class="detail-field" *ngIf="ItemData?.Phone">
                                    <span class="field-label">Telefone</span>
                                    <span class="field-value">{{ ItemData.Phone }}</span>
                                </div>

                                <div class="detail-field" *ngIf="ItemData?.MobilePhone">
                                    <span class="field-label">Telemóvel</span>
                                    <span class="field-value">{{ ItemData.MobilePhone }}</span>
                                </div>

                                <div class="detail-field" *ngIf="ItemData?.Email">
                                    <span class="field-label">Email</span>
                                    <span class="field-value">{{ ItemData.Email }}</span>
                                </div>

                            </div>
                        </div>
                    </ion-col>
                </ion-row>

                <ng-template #noItems>
                    <ion-row>
                        <ion-col>
                            <no-items></no-items>
                        </ion-col>
                    </ion-row>
                </ng-template>

            </ng-container>

        </ion-grid>

    </ng-container>

    <!-- ═══ CRUD mode — lista de estabelecimentos do marketplace ═══ -->
    <ng-container *ngIf="Mode === 'crud'">

        <ion-grid class="table">

            <ion-row class="table-header">
                <ion-col size="1" class="flex-align-center flex-justify-center"></ion-col>
                <ion-col size="3" class="flex-align-center">Nome</ion-col>
                <ion-col size="3" class="flex-align-center">Morada</ion-col>
                <ion-col size="5" class="flex-align-center">URL</ion-col>
            </ion-row>

            <ion-row class="table-body" [class.clickable]="!IsAssociated" [class.row-disabled]="IsAssociated"
                [class.row-selected]="SelectedItem?.IdExternal === item?.IdExternal" *ngFor="let item of Data"
                (click)="SelectItem(item)">

                <ion-col size="1" class="flex-align-center flex-justify-center">
                    <ion-icon
                        [name]="SelectedItem?.IdExternal === item?.IdExternal ? 'checkmark-circle' : 'ellipse-outline'"
                        [color]="IsAssociated ? 'medium' : (SelectedItem?.IdExternal === item?.IdExternal ? 'primary' : 'medium')">
                    </ion-icon>
                </ion-col>

                <ion-col size="3" class="flex-align-center">{{ item?.Name || '--' }}</ion-col>

                <ion-col size="3" class="flex-align-center">
                    {{ (item?.Address || '--') + (item?.ZipCode ? ', ' + item?.ZipCode : '') }}
                </ion-col>

                <ion-col size="5" class="flex-align-center url-col">
                    <a *ngIf="item?.Url" [href]="item?.Url" target="_blank" rel="noopener noreferrer"
                        (click)="$event.stopPropagation()">
                        {{ item?.Url }}
                    </a>
                    <span *ngIf="!item?.Url">--</span>
                </ion-col>

            </ion-row>

            <ion-row *ngIf="!Data?.length">
                <ion-col>
                    <no-items></no-items>
                </ion-col>
            </ion-row>

        </ion-grid>

    </ng-container>

    <!-- Lightbox — partilhado -->
    <div class="image-lightbox" *ngIf="PreviewImage" (click)="ClosePreview()">
        <img [src]="PreviewImage" (click)="$event.stopPropagation()" />
        <ion-button class="lightbox-close" fill="clear" color="light" shape="round" (click)="ClosePreview()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </div>

</ion-content>

<!-- CRUD mode — footer com termos & condições. Checkbox sempre visível;
     bloqueada quando já associado. Botão Associar está na toolbar. -->
<ion-footer *ngIf="Mode === 'crud'">
    <ion-toolbar class="ion-padding-horizontal">
        <ion-item lines="none" style="margin-top:0">
            <ion-checkbox slot="start" [checked]="TermsAccepted" [disabled]="IsAssociated"
                (ionChange)="TermsAccepted = $event.detail.checked"></ion-checkbox>
            <ion-label class="ion-text-wrap ion-padding-start">
                <div [innerHTML]="Marketplace?.Compliance?.Description"></div>
            </ion-label>
        </ion-item>
        <ion-buttons slot="end">
            <ion-button *ngIf="!IsAssociated" fill="solid" color="primary" [disabled]="!CanAssociate"
                (click)="OnAssociate()">
                Associar
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>